import * as React from "react";
import PropTypes from "prop-types";
import omit from "lodash/omit";

import { FaInfoCircle } from "react-icons/fa";
import CircularProgress from "material-ui-old/CircularProgress";
import Button from "./Button";

import * as userUtils from "../modules/user/utils";

import * as styles from "../styles/components/EmailAndPasswordForm.css";

export default class EmailAndPasswordForm extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handlePasswordToggle = this.handlePasswordToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            email: this.props.emailAddress,
            password: this.props.password,
            remember: true,
            passwordVisible: false
        };
    }

    componentWillReceiveProps(newProps) {
        if (
            this.state.email !== newProps.emailAddress ||
            this.state.password !== newProps.password
        ) {
            this.setState({
                email: newProps.emailAddress,
                password: newProps.password
            });
        }
    }

    handleTextChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleCheckboxChange(event) {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
    }

    handlePasswordToggle(event) {
        event.preventDefault();
        const passwordVisible = !this.state.passwordVisible;
        this.setState({ passwordVisible });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(omit(this.state, ["passwordVisible"]));
    }

    renderHintContent() {
        if (this.props.renderHintContent) {
            return this.props.renderHintContent();
        }
        return (
            <div className={styles.requirements}>
                <p>Requirements</p>{" "}
                <FaInfoCircle className={styles.icon} />
                <p className={styles.requirementsTooltip}>
                    A minimum of 8 characters long. Can include letters, numbers
                    and special characters.
                </p>
            </div>
        );
    }

    render() {
        const emailReadonly = !this.props.emailEditable;
        const emailEditableStyle =
            styles[this.props.emailEditable ? "editable" : "readonly"];
        const emailOnChange = emailReadonly ? null : this.handleTextChange;

        const passwordInputType = this.state.passwordVisible
            ? "text"
            : "password";
        const passwordToggleIcon = this.state.passwordVisible
            ? "fa-eye"
            : "fa-eye-slash";
        const email = this.state.email || "";
        const password = this.state.password || "";
        const isEmailValid = this.props.emailValidator(email);
        const isPasswordValid = this.props.passwordValidator(password);

        return (
            <form className={`${styles.loginForm}`}>
                {this.props.isLoading && (
                    <div className={styles.loading}>
                        <CircularProgress />
                    </div>
                )}

                <h1 className={styles.formHeader}>{this.props.formHeader}</h1>
                {this.props.instructionText && (
                    <p className={styles.instructions}>
                        {this.props.instructionText}
                    </p>
                )}

                <div
                    className={`${styles.field} ${
                        styles.email
                    } ${emailEditableStyle}`}
                >
                    <input
                        type="text"
                        id="set-password-form-email"
                        name="email"
                        placeholder={this.props.emailPlaceholder}
                        aria-label="Email address"
                        readOnly={emailReadonly}
                        onChange={emailOnChange}
                        value={email}
                    />
                </div>
                <div
                    className={`${styles.field} ${styles.password} ${
                        styles["editable"]
                    }`}
                >
                    <input
                        type={passwordInputType}
                        id="set-password-form-password"
                        className={styles.password}
                        name="password"
                        placeholder={this.props.passwordPlaceholder}
                        aria-label="Password"
                        onChange={this.handleTextChange}
                        value={password}
                    />
                    <button
                        type="button"
                        className={styles.passwordToggle}
                        onClick={this.handlePasswordToggle}
                    >
                        <i className={`fa ${passwordToggleIcon}`} />
                    </button>
                </div>
                <div className={`${styles.field} ${styles.rememberAndHint}`}>
                    <input
                        type="checkbox"
                        id="set-password-form-remember"
                        className={styles.remember}
                        name="remember"
                        defaultChecked={this.state.remember}
                        onChange={this.handleCheckboxChange}
                    />
                    <label
                        htmlFor="set-password-form-remember"
                        className={styles.remember}
                    >
                        Remember me
                    </label>
                    <div className={styles.hint}>
                        {this.renderHintContent()}
                    </div>
                </div>

                <Button
                    type="submit"
                    wrapperClass={styles.login}
                    onClick={this.handleSubmit}
                    disabled={!isEmailValid || !isPasswordValid}
                >
                    {this.props.submitButtonLabel}
                </Button>

                <div className={styles.supportText}>
                    <p>
                        If you are having trouble logging in, please{" "}
                        <a href="mailto:support@wevoconversion.com?Subject=Login%20issues">
                            email support
                        </a>
                        .
                    </p>
                </div>
            </form>
        );
    }
}

EmailAndPasswordForm.propTypes = {
    formHeader: PropTypes.string.isRequired,
    instructionText: PropTypes.string,

    emailAddress: PropTypes.string,
    emailEditable: PropTypes.bool,
    emailPlaceholder: PropTypes.string,
    emailValidator: PropTypes.func,

    password: PropTypes.string,
    passwordPlaceholder: PropTypes.string,
    passwordValidator: PropTypes.func,

    submitButtonLabel: PropTypes.string,

    renderHintContent: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired
};

EmailAndPasswordForm.defaultProps = {
    emailAddress: "",
    emailEditable: true,
    emailPlaceholder: "email@domain.com",
    emailValidator: userUtils.isValidEmail,

    password: "",
    passwordPlaceholder: "Password",
    passwordValidator: password => password,

    submitButtonLabel: "Login"
};



// WEBPACK FOOTER //
// ./src/components/EmailAndPasswordForm.js